import { orderedOptions, optionLabel } from "../../logistica/configurazione/adapters";
import React from "react";

function InputDatoTendinaGenerico({permessoScrittura,inputLabel,elencoDati,tabName,datoName,datoId,datoValue,datoPlaceHolder,datoOnChange,datoClass,inputClass,labelClass,classiTastoSblocco,tastoCopiaAspetto,modCompatta}) {
        
     //ATTENZIONE QUESTIONE CONTROVERSA: questo aggiunge il valore attuale all'elenco valori se non è presente in lista
    const opzioni = orderedOptions(elencoDati);
    if (!opzioni.includes(datoValue) && datoValue !== null && datoValue !== undefined) opzioni.push(datoValue);

    if (permessoScrittura === "NO") {
        return(
            <p className={datoClass}><strong>{inputLabel}: </strong>{optionLabel(elencoDati, datoValue)}</p>
        )
    } else {
        
        if (modCompatta === "SI") {
            return(
                <div className={datoClass+" flex items-center mb2"}>
                    <div for={datoId}
                        className={labelClass+" pointer mr2 labInp"} 
                        onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
                    >{inputLabel}</div>
                                <select
                                    id={datoId}
                                    placeholder={datoPlaceHolder}
                                    name={datoName}
                                    value={datoValue}
                                    autoComplete="off"
                                    onChange={datoOnChange}
                                    className={inputClass}
                                    
                                >
                                    <option key={0} value="" ></option>
                                {
                                    opzioni.map((dato,ind) => <option key={ind+1} value={dato} >{optionLabel(elencoDati, dato)}</option>)
                                }         
                                </select>          
                    {tastoCopiaAspetto !== "NO" && <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button>}
                    
                </div>
            )
        } else {
            return (
                <div className="mb1">
                    <label for={datoId}
                        className="pointer" 
                        onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
                    >{inputLabel}</label><br />
                                <select
                                    id={datoId}
                                    placeholder={datoPlaceHolder}
                                    name={datoName}
                                    value={datoValue}
                                    autoComplete="off"
                                    onChange={datoOnChange}
                                    className={datoClass}
                                >{
                                    opzioni.map((dato,ind) => <option key={ind} value={dato} >{optionLabel(elencoDati, dato)}</option>)
                                }                    
                                 </select>           
                    {tastoCopiaAspetto !== "NO" && <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button>}
                    <br />  
                </div>
            )
        }
    }
}

export default InputDatoTendinaGenerico;